import { Engine } from 'json-rules-engine';

class GlobalFacts {

    facts = {
        make: null,
        model: null,
        year: null,
        body_style: null,
        bed_length: null,
        productHandle: window.__VPV.pdp?.productHandle,
        productType: window.__VPV.pdp?.productType,
        template: window.__VPV.pdp?.template,
        id: null,
        sku: null,
        availableForSale: null,
        price: null,
        filteredHandles: [],
        filteredSKUs: [],
    }

    updateNeeded = false;

    constructor(){
        this.productHandle = window.__VPV.pdp?.productHandle;
        this.productType = window.__VPV.pdp?.productType;
        this.template = window.__VPV.pdp?.template;
        window.addEventListener('vehicleSelected', this.queueFactCollection);
        window.addEventListener('variant:change', this.queueFactCollection);
        window.addEventListener('vehicleCleared', this.queueFactCollection);
        window.addEventListener("remainingVariants:change", this.queueFactCollection);
    }

    queueFactCollection = () => {
        this.updateNeeded = true;
        requestAnimationFrame(() => {
            if(this.updateNeeded){
                this.updateNeeded = false;
                this.collectFacts();
            }
        });
    }

    collectFacts = async () => {

        const remainingVariants = window.__VPV.pdp?.remainingVariants || [];
        const selectedVariant = remainingVariants?.length === 1 ? remainingVariants[0] : null;

        const filteredHandles = new Set();
        const filteredSKUs = new Set();
        
        window.__VPV.vehicleData?.bySelection?.forEach((vehicle) => {
            vehicle.products?.forEach((product) => {
                filteredHandles.add(product.productHandle);
                filteredSKUs.add(product.sku);
            });
        });

        const selectedVehicle = window.VehicleData?.getSelectedVehicle();
        let facts = {
            ...this.facts,
            make: selectedVehicle?.make,
            model: selectedVehicle?.model,
            year: selectedVehicle?.year,
            body_style: selectedVehicle?.body_style,
            bed_length: selectedVehicle?.bed_length,
            id: selectedVariant?.id,
            sku: selectedVariant?.sku,
            availableForSale: selectedVariant?.availableForSale,
            price: selectedVariant?.price.amount,
            filteredHandles: Array.from(filteredHandles),
            filteredSKUs: Array.from(filteredSKUs),
        }
        
        if(this.deepEqual(this.facts, facts)){
            return;
        }
        this.facts = facts;

        const event = new CustomEvent('globalFacts:updated', {
            detail: {
                facts: this.facts,
            },
            bubbles: true,
            composed: true,
        });
        window.dispatchEvent(event);

    }

    // deep compare two objects
    deepEqual = (obj1, obj2) => {
        if (obj1 === obj2) return true;
        if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;
        if (obj1 === null || obj2 === null) return false;
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;

        for (let key in obj1) {
            if (!Object.prototype.hasOwnProperty.call(obj2, key)) return false;
            if (!this.deepEqual(obj1[key], obj2[key])) return false;
        }
        return true;
    }

}

export class VisibilityRules extends HTMLElement {
    constructor(){
      super();
      if(window.localStorage && window.localStorage.getItem('debug') == "visibility-rules"){
        this.debug = true;
      }
      window.GlobalFacts = window.GlobalFacts || new GlobalFacts();
    }
    connectedCallback() {
      try{
        this.rulesEl = this.querySelector('#' + this.dataset.rules);
        this.rules = JSON.parse(this.rulesEl.innerHTML);
      }catch(e){
        console.error(e);
      }
      this.engine = new Engine();
      this.engine.addRule({
        conditions: this.rules,
        event: {
          type: 'show'
        }
      });

      window.addEventListener('globalFacts:updated', this.evaluateRules);

    }

    evaluateRules = () => {
        this.debug && console.log("Evaluating Rules");

        const facts  = window.GlobalFacts.facts;

        this.debug && console.log("Visibility Conditions:", this.rules);
        this.debug && console.log("Visibility Facts:", facts);
        this.engine.run(facts).then(({ events }) => {
            this.debug && console.log("Visibility Events:", events);
            let show = false;
            events.forEach(event => {
                if(event.type == 'show'){
                    show = true;   
                }
            });
            if(show){
                this.removeAttribute('hidden');
            }else{
                this.setAttribute('hidden', 'hidden');
            }
        });
    }
}